/**
 * Talking points filter options for meeting list filtering
 */
export const MEETING_TALKING_POINTS_FILTER = {
  HAS_TALKING_POINTS: 'hasTalkingPoints',
  HAS_PENDING: 'hasPending',
  ALL_DISCUSSED: 'allDiscussed',
};

/**
 * Human-readable labels for talking points filter
 */
export const MEETING_TALKING_POINTS_FILTER_LABELS = {
  [MEETING_TALKING_POINTS_FILTER.HAS_TALKING_POINTS]: 'Has Talking Points',
  [MEETING_TALKING_POINTS_FILTER.HAS_PENDING]: 'Has Pending Points',
  [MEETING_TALKING_POINTS_FILTER.ALL_DISCUSSED]: 'All Discussed',
};

/**
 * Array of talking points filter options for use in dropdowns
 */
export const MEETING_TALKING_POINTS_FILTER_OPTIONS = [
  { value: '', label: 'All Meetings' },
  { value: MEETING_TALKING_POINTS_FILTER.HAS_TALKING_POINTS, label: MEETING_TALKING_POINTS_FILTER_LABELS[MEETING_TALKING_POINTS_FILTER.HAS_TALKING_POINTS] },
  { value: MEETING_TALKING_POINTS_FILTER.HAS_PENDING, label: MEETING_TALKING_POINTS_FILTER_LABELS[MEETING_TALKING_POINTS_FILTER.HAS_PENDING] },
  { value: MEETING_TALKING_POINTS_FILTER.ALL_DISCUSSED, label: MEETING_TALKING_POINTS_FILTER_LABELS[MEETING_TALKING_POINTS_FILTER.ALL_DISCUSSED] },
];
